export default {
  title: {
    id: 'product_page_obsolete_modal_title',
    defaultMessage: 'Obsolete',
  },
  close: {
    id: 'product_page_obsolete_modal_close',
    defaultMessage: 'Close',
  },
  mainTitle: {
    id: 'product_page_obsolete_modal_main_title',
    defaultMessage: 'The Obsolete Computer',
  },
  subtitle: {
    id: 'product_page_obsolete_modal_subtitle',
    defaultMessage:
      'Find the “fresh” in refurbished. This device has been authenticated by certified industry professionals.',
  },
  item1Title: {
    id: 'product_page_obsolete_modal_item_1_title',
    defaultMessage: '100% fully functional',
  },
  item1Text: {
    id: 'product_page_obsolete_modal_item_1_text',
    defaultMessage:
      'Tested and checked by industry pros, backed by a 1-year warranty and free 30-day returns.',
  },
  item2Title: {
    id: 'product_page_obsolete_modal_item_2_title',
    defaultMessage: 'Clean slate',
  },
  item2Text: {
    id: 'product_page_obsolete_modal_item_2_text',
    defaultMessage:
      'Squeaky clean inside and out, complete with a factory data reset.',
  },
  item3Title: {
    id: 'product_page_obsolete_modal_item_3_title',
    defaultMessage: 'No red flags',
  },
  item3Text: {
    id: 'product_page_obsolete_modal_item_3_text',
    defaultMessage:
      'No malware in sight. Device not locked, stolen, or fraudulently sourced.',
  },
  link: {
    id: 'product_page_obsolete_modal_link',
    defaultMessage: '',
  },
  linkTitle: {
    id: 'product_page_obsolete_modal_link_title',
    defaultMessage: 'About planned obsolescence',
  },
  faqTitle: {
    id: 'product_page_obsolete_modal_faq_title',
    defaultMessage: 'Frequently asked questions',
  },
  faqSubtitle: {
    id: 'product_page_obsolete_modal_faq_subtitle',
    defaultMessage: 'About our obsolete computer',
  },
  faqQuestion1: {
    id: 'product_page_obsolete_modal_question_1',
    defaultMessage: '',
  },
  faqAnswer1: {
    id: 'product_page_obsolete_modal_answer_1',
    defaultMessage: '',
  },
  faqQuestion2: {
    id: 'product_page_obsolete_modal_question_2',
    defaultMessage: '',
  },
  faqAnswer2: {
    id: 'product_page_obsolete_modal_answer_2',
    defaultMessage: '',
  },
  faqQuestion3: {
    id: 'product_page_obsolete_modal_question_3',
    defaultMessage: '',
  },
  faqAnswer3: {
    id: 'product_page_obsolete_modal_answer_3',
    defaultMessage: '',
  },
}
